import { render } from "./AppLayout.vue?vue&type=template&id=ec29b784&scoped=true"
import script from "./AppLayout.vue?vue&type=script&lang=js"
export * from "./AppLayout.vue?vue&type=script&lang=js"

import "./AppLayout.vue?vue&type=style&index=0&id=ec29b784&lang=scss&scoped=true"

import exportComponent from "/home/duanpengyuan/Projects/dcp-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec29b784"]])

export default __exports__